@let companionChatActive = companionChatActive$ | async;

<div
  toastContainer
  nimbusTheme
  class="container-fluid flex-container full-screen"
  [class.stand-alone]="isStandAlone"
  [class.companion-split-screen]="companionChatActive"
  [target]="applicationElement"
>
  @if (loaded$ && (loaded$ | async)) {
    @if (showMenu$ | async) {
      <nimbus-menu></nimbus-menu>
    }
    <div class="row" role="main">
      <router-outlet></router-outlet>
    </div>
    @defer (when companionChatActive) {
      <nimbus-companion-split-screen-resizer></nimbus-companion-split-screen-resizer>
      <nimbus-companion-chat-panel class="companion-split-screen-panel" [splitScreen]="true"></nimbus-companion-chat-panel>
    }
  }
</div>
@if (showLoadingScreen$ | async) {
  <nimbus-spinner [small]="false" [height]="120"></nimbus-spinner>
}
<nimbus-error-screen mode="fullscreen"></nimbus-error-screen>
